import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mb-0" }, "Add Email Address"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, "you can accept invitations sent to any verified email address you add to your account (such as a school email) ")
], -1)
const _hoisted_2 = { class: "d-flex justify-content-center mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputGroup = _resolveComponent("InputGroup")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ModalBase = _resolveComponent("ModalBase")!

  return (_openBlock(), _createBlock(_component_ModalBase, {
    title: "Manage",
    ref: "modal"
  }, {
    body: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_InputGroup, {
        label: "Email Address",
        "is-required": true
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["form-control", {'is-invalid': _ctx.v$.entity.email.$error}]),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.entity.email) = $event)),
            type: "email"
          }, null, 2), [
            [_vModelText, _ctx.entity.email]
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Button, {
          type: "primary",
          onClick: _ctx.add,
          "is-loading": _ctx.isLoading
        }, {
          default: _withCtx(() => [
            _createTextVNode("Add Email")
          ]),
          _: 1
        }, 8, ["onClick", "is-loading"])
      ])
    ]),
    _: 1
  }, 512))
}